export default {
  /**
   * バリデーションチェックなし
   */
  NONE: 'none',

  /**
   * 必須エラー（入力）
   */
  INPUT_REQUIRED: 'inputRequired',

  /**
   * 必須エラー（選択）
   */
  SELECT_REQUIRED: 'selectRequired',

  /**
   * 必須エラー（複数選択）
   */
  MULTI_SELECT_REQUIRED: 'multiSelectRequired',

  /**
   * Email 入力形式エラー
   */
  EMAIL: 'email',

  /**
   * メールドメインエラー
   */
  MAIL_DOMAIN: 'mailDomain',

  /**
   * URL 入力形式エラー
   */
  URL: 'url',

  /**
   * パスワード入力形式エラー
   */
  PASSWORD: 'password',

  /**
   * 半角数字入力形式エラー
   */
  NUMBER: 'number',

  /**
   * かな入力形式エラー
   */
  KANA: 'kana',

  /**
   * 日付入力形式エラー
   */
  DATE: 'date',

  /**
   * 電話番号入力形式エラー
   */
  PHONE_NUMBER: 'phoneNumber',

  /**
   * 入力文字数範囲エラー
   */
  RANGE: 'range',

  /**
   * 入力文字最大数エラー
   */
  MAX_LENGTH: 'maxLength',

  /**
   * 入力文字最小数エラー
   */
  MIN_LENGTH: 'minLength',
} as const
